export default __webpack_public_path__ + "static/media/Sonos.174e9c1a.svg";